/**
 * Openhome
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:16:41
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:16:41
 */

'use client'

import PropTypes from 'prop-types'
import Folding from '@comp/Folding'
import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import PropertyItemScoff from '../PropertyItemScoff'
import OpenhomeCard from './OpenhomeCard'
import SendEmailInput from './SendEmailInput'

export default function Openhome({
  house = {}
}) {
  const { auction, openHomes } = house
  const th = useTranslations('house')

  const hasOpenhome = useMemo(() => openHomes?.length > 0, [openHomes])
  const label = useMemo(() => (hasOpenhome ? th('openhome') : th('bookToSee')), [hasOpenhome, th])
  
  return (
    <>
      <div
        data-modulename={label}
        id="module-openhome"
      />
      {auction && (
        <PropertyItemScoff title={th('auction')}>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            <OpenhomeCard type={3} data={auction} house={house} />
          </div>
        </PropertyItemScoff>
      )}
      <div className={clsx([auction && '-mt-3 md:-mt-5'])}>
        <PropertyItemScoff title={label} border={false}>
          {hasOpenhome 
            ? (
              <Folding height={150}>
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                  {openHomes.map((item, index) => (
                    <OpenhomeCard data={item} key={index} house={house} />
                  ))}
                </div>
              </Folding>
            )
            : <SendEmailInput house={house} />}
        </PropertyItemScoff>
      </div>
    </>
  )
}

Openhome.propTypes = {
  house: PropTypes.object,
}
